let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UDzr")).then(() => parcelRequire('gn51B'));